export default function formatAmericanDashDate(d) {
  const dayStr = `${d.getDate()}`.padStart(2, '0')
  const monthStr = `${d.getMonth() + 1}`.padStart(2, '0')
  const yearStr = `${d.getFullYear()}`
  return `${yearStr}-${monthStr}-${dayStr}`
}
